import { AnimatePresence } from "framer-motion";
import React, { useEffect, useState } from "react";
import { TimersContext, TwitchChannelContext } from "../../contexts/index.js";
import useEbsApiClient from "../../hooks/useEbsApiClient.js";
import useFollowerRaffleLogic, {
  FOLLOWER_STATUSES,
} from "../../hooks/useFollowerRaffleLogic.js";
import Flyout from "../Flyout/Flyout.js";
import FollowerBuilder from "../FollowerBuilder/FollowerBuilder.js";
import HelpHinder from "../HelpHinder/HelpHinder.js";
import Raffle from "../Raffle/Raffle.js";
import SafeZones from "../SafeZones/SafeZones.js";

const VideoOverlay = () => {
  const {
    activeRaffle,
    enterRaffle,
    dismissRaffle,
    follower,
    createFollower,
    premiumBitsCost,
  } = useFollowerRaffleLogic();
  const [channelInfo, setChannelInfo] = useState(null);
  const [timers, setTimers] = useState(null);
  const ebsApiClient = useEbsApiClient();

  useEffect(() => {
    (async () => {
      const [{ data: channelData }, { data: timersData }] = await Promise.all([
        ebsApiClient.get("/channel"),
        ebsApiClient.get("/timers"),
      ]);
      setChannelInfo(channelData);
      setTimers(timersData);
    })();
  }, []);

  if (!channelInfo || !timers) {
    return null;
  }

  return (
    <TwitchChannelContext.Provider value={channelInfo}>
      <TimersContext.Provider value={timers}>
        <SafeZones />
        <HelpHinder />
        <AnimatePresence>
          {Boolean(activeRaffle) && (
            <Raffle
              activeRaffle={activeRaffle}
              hasFollower={Boolean(follower)}
              onDismissRaffle={dismissRaffle}
              onEnterRaffle={enterRaffle}
            />
          )}
        </AnimatePresence>
        {Boolean(
          follower && follower.status === FOLLOWER_STATUSES.READY_FOR_CREATION
        ) && (
          <Flyout direction="left">
            <FollowerBuilder
              premiumBitsCost={premiumBitsCost}
              onFinishBuilding={createFollower}
            />
          </Flyout>
        )}
      </TimersContext.Provider>
    </TwitchChannelContext.Provider>
  );
};

export default VideoOverlay;
